import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { isMultiClient } from '@ddv/behaviors';
import { Client } from '@ddv/models';
import { InitializationErrorCollectorService } from '@ddv/navigation';
import { ClientsService } from '@ddv/reference-data';
import { catchError, Observable, of } from 'rxjs';

export const clientsResolver: ResolveFn<Client[]> = (route): Observable<Client[]> => {
    const errorCollector = inject(InitializationErrorCollectorService);
    const service = inject(ClientsService);

    const clientCode = route.paramMap.get('clientCode') ?? '';
    if (!isMultiClient(clientCode)) {
        return of([]);
    }

    return service.fetchClients(clientCode)
        .pipe(catchError((e) => {
            errorCollector.addError('Failed to load client list', e);
            return of([]);
        }));
};
